const sourceCodeFileTypes = {
  HTML: 'html',
  CSS: 'css',
  JS: 'js'
};

export default sourceCodeFileTypes;